/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RaceClass } from '../../models/race-class';

export interface GetRaceClassByRaceId$Params {
  raceGuid: string;
}

export function getRaceClassByRaceId(http: HttpClient, rootUrl: string, params: GetRaceClassByRaceId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RaceClass>>> {
  const rb = new RequestBuilder(rootUrl, getRaceClassByRaceId.PATH, 'get');
  if (params) {
    rb.path('raceGuid', params.raceGuid, {"style":"simple"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RaceClass>>;
    })
  );
}

getRaceClassByRaceId.PATH = '/races/{raceGuid}/classes';
